import styled from '@emotion/styled';
import React from 'react';
import Dialog from '../Dialogs/Dialog';
const Basic = ({ children, ...rest }) => (children ? <span {...rest}>{children}</span> : null);

export const TextStatic = styled(Basic)`
    background-color: rgb(238, 238, 238);
    color: black;
    font-weight: 500;
`;

export const Box = styled.div`
    margin-top: 2rem;
    border-top: 1px solid lightgrey;
    padding: 2rem 0;
    border-bottom: 1px solid lightgrey;
    /* margin-bottom: 2rem; */
`;
export const getDialog = (message, flag, event) => {
    const me = this;
    const dialog = flag ? (
        <Dialog onClose={event.bind(me)} title={message} show={flag} closeButton="false" closeButtonText="OK"></Dialog>
    ) : null;
    return dialog;
};
export default function FormGroup({ label, children }) {
    return (
        <div className="form-group">
            <div className="form-group row">
                <div className="col-sm-3 col-lg-2 col-form-label">{label}</div>
                <div className="col-sm-7 col-form-control">{children}</div>
            </div>
        </div>
    );
}
